export const TIME_OPTIONS = {
  ONE_SECOND: 1000 * 1,
  TEN_SECONDS: 1000 * 10,
  THIRTY_SECONDS: 1000 * 30,
  ONE_MINUTE: 1000 * 60 * 1,
  TWO_MINUTES: 1000 * 60 * 2,
  FIVE_MINUTES: 1000 * 60 * 5,
  TEN_MINUTES: 1000 * 60 * 10,
  FIFTEEN_MINUTES: 1000 * 60 * 15,
  TWENTY_MINUTES: 1000 * 60 * 20,
  THIRTY_MINUTES: 1000 * 60 * 30,
  FORTY_FIVE_MINUTES: 1000 * 60 * 45,
  ONE_HOUR: 1000 * 60 * 60,
  TWO_HOURS: 1000 * 60 * 60 * 2,
  THREE_HOURS: 1000 * 60 * 60 * 3,
  SIX_HOURS: 1000 * 60 * 60 * 6,
  TWELVE_HOURS: 1000 * 60 * 60 * 12,
  ONE_DAY: 1000 * 60 * 60 * 24,
  TWO_DAYS: 1000 * 60 * 60 * 24 * 2,
  ONE_WEEK: 1000 * 60 * 60 * 24 * 7,
  INFINITY: Infinity,
} as const;
